import React from "react";
import { Trans, useTranslation } from "react-i18next";

// @ts-ignore
import { Link } from "react-router-dom";
import styled from "styled-components";
// @ts-ignore
import classNames from "classnames";

import Images from "../../../assets/images/Images";

const Wrapper = styled.main`
  padding-left: 10%;
  padding-right: 10%;
  padding-top: 5em;
  background-color: white;

  .gip-home-section {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: auto auto;
    grid-gap: 5%;
    position: relative;
    padding-bottom: 5em;
  }

  .gip-home-section__header-dot {
    align-self: center;
    background-color: #9A0214;
    border-radius: 0.75em;
    grid-column: 1;
    height: 0.75em;
    justify-self: center;
    width: 0.75em;
  }

  .gip-home-section__header-title {
    color: #737373;
    font-family: DMSans-Black;
    font-size: 2rem;
    grid-column-start: 2;
    grid-column-end: 5;
    margin: 0;
    margin-bottom: 0.25em;
    z-index: 2;
  }

  .gip-home-section__header-title-red {
    color: #D81E05;
    font-size: 2.25rem;
    z-index: 2;
  }

  .gip-home-section__description {
    color: #1A1714;
    font-family: AvenirNextLTPro-Regular;
    font-size: 0.833rem;
    grid-column-start: 2;
    grid-column-end: 5;
    line-height: 1.25rem;
    z-index: 2;
  }
`;

const SectionImage = styled.img`
  bottom: 0px;
  opacity: 0.15;
  position: absolute;
  width: 200px;
  z-index: 1;


  &.left {
    left: -10px;
  }

  &.right {
    right: -10px;
  }
`;

interface SectionProps {
  titleBlack: string,
  titleRed: string,
  description: string | JSX.Element,
  image: string,
  isLeft: boolean,
}

const Section = ({ titleBlack, titleRed, description, image, isLeft }: SectionProps) => {
  return (
    <section className='gip-home-section'>
      <span className='gip-home-section__header-dot' />
      <h2 className='gip-home-section__header-title'>
        { titleBlack }
        <br />
        <span className='gip-home-section__header-title-red'>{ titleRed }</span>
      </h2>
      <p className='gip-home-section__description'>{ description }</p>
      <SectionImage
        src={ image }
        className={ classNames({ 'left': isLeft }, { 'right': !isLeft }) }
      />
    </section>
  )
};

const GipHome = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Section
        titleBlack={ t('economicResearch.mainSection.title') }
        titleRed={ '' }
        description={
          <Trans i18nKey='economicResearch.mainSection.description'>
            Description <Link to='/gip/bps'></Link> description
          </Trans>
        }
        image={ Images.homeImage2 }
        isLeft={ true }
      />
      <Section
        titleBlack={ t('economicResearch.section1.title') }
        titleRed={ '' }
        description={
          <Trans i18nKey='economicResearch.section1.description'>
            Description <a href='https://www.fundacionmapfre.org/documentacion/publico/i18n/catalogo_imagenes/grupo.do?path=1097445' target='_blank'>técnica</a>
          </Trans>
        }
        image={ Images.homeImage4 }
        isLeft={ false }
      />
      <Section
        titleBlack={ t('economicResearch.section2.title') }
        titleRed={ '' }
        description={
           t('economicResearch.section2.description')
        }
        image={ Images.homeImage5 }
        isLeft={ true }
      />
      <Section
        titleBlack={ t('economicResearch.section3.title') }
        titleRed={ '' }
        description={
          <Trans i18nKey='economicResearch.section3.description'>
            Description <Link to='/gip/bps'>BPS</Link>
          </Trans>
        }
        image={ Images.homeImage6 }
        isLeft={ false }
      />
      <Section
        titleBlack={ t('economicResearch.section4.title') }
        titleRed={ '' }
        description={
          t('economicResearch.section4.description')
        }
        image={ Images.homeImage7 }
        isLeft={ true }
      />
      <Section
        titleBlack={ t('economicResearch.section5.title') }
        titleRed={ '' }
        description={
          t('economicResearch.section5.description')
        }
        image={ Images.homeImage7 }
        isLeft={ false }
      />
      <Section
        titleBlack={ t('economicResearch.section6.title') }
        titleRed={ '' }
        description={
          t('economicResearch.section6.description')
        }
        image={ Images.homeImage8 }
        isLeft={ true }
      />
      <Section
        titleBlack={ t('economicResearch.section7.title') }
        titleRed={ '' }
        description={
          t('economicResearch.section7.description')
        }
        image={ Images.homeImage8 }
        isLeft={ false }
      />
      <Section
        titleBlack={ t('economicResearch.section8.title') }
        titleRed={ '' }
        description={
          t('economicResearch.section8.description')
        }
        image={ Images.homeImage8 }
        isLeft={ true }
      />
      <Section
        titleBlack={ t('economicResearch.section9.title') }
        titleRed={ '' }
        description={
          t('economicResearch.section9.description')
        }
        image={ Images.homeImage8 }
        isLeft={ false }
      />
      <Section
        titleBlack={ t('economicResearch.footerSection.title1') + ' ' + t('economicResearch.footerSection.title2') }
        titleRed={ '' }
        description={
          <Trans i18nKey='economicResearch.footerSection.description'>
            Description <a href="https://www.mapfre.com/informacion-sectorial/indice-global-potencial-asegurador/" target='_blank'>página</a>
          </Trans>
        }
        image={ Images.homeImage8 }
        isLeft={ true }
      />
    </Wrapper>
  )
};

export default GipHome;
